import { Toast, Tooltip, Popover } from 'bootstrap';
import $ from 'jquery';
//import 'jquery-ui/dist/jquery-ui.min.js';

class LavishTemplate {
  constructor() {
      this.init();
  }

  init() {
    this.initSidebar();
    this.sidebarToggling();
    this.stickyHeader();
  }

  initSidebar() {
    var animationSpeed = 300;

    $(".sidebar-menu").on("click", "li a", function (e) {
      var $this = $(this);
      var checkElement = $this.next();

      // Check if it's a treeview menu
      if (checkElement.is(".treeview-menu")) {
        e.preventDefault();

        // If menu is currently being animated, ignore the click
        if (checkElement.is(":animated")) {
          return;
        }

        // If menu is visible, close it
        if (checkElement.is(":visible")) {
          checkElement.slideUp(animationSpeed, function () {
            checkElement.removeClass("menu-open");
          }).parent("li").removeClass("active");
        }
        // If menu is hidden, open it
        else {
          // Close all visible sibling menus (excluding the current one)
          var parent = $this.parents("ul").first();
          parent.find("ul:visible").not(checkElement).slideUp(animationSpeed).removeClass("menu-open");

          // Open the clicked menu
          checkElement.slideDown(animationSpeed, function () {
            checkElement.addClass("menu-open");
            parent.find("li.active").removeClass("active");
            $this.parent("li").addClass("active");
          });
        }
      }
    });
  }

  sidebarToggling() {
      //toggle sidebar
    $("#toggle-sidebar").on("click", function () {
      $(".page-wrapper").toggleClass("toggled");
    });

    // Pin sidebar on click
    $("#pin-sidebar").on("click", function () {
      const $icon = $(this).find("i");

      if ($(".page-wrapper").hasClass("pinned")) {
        // Unpin sidebar
        $(".page-wrapper").removeClass("pinned");
        $("#sidebar").unbind("hover");

        // Change icon back to default
        $icon.removeClass("bi-layout-sidebar-reverse").addClass("bi-layout-sidebar");
      } else {
        // Pin sidebar
        $(".page-wrapper").addClass("pinned");
        $("#sidebar").hover(
          function () {
            //console.log("mouseenter");
            $(".page-wrapper").addClass("sidebar-hovered");
          },
          function () {
            //console.log("mouseout");
            $(".page-wrapper").removeClass("sidebar-hovered");
          }
        );

        // Change icon to reverse
        $icon.removeClass("bi-layout-sidebar").addClass("bi-layout-sidebar-reverse");
      }
    });

    // Pinned sidebar
    $(function () {
      //$(".page-wrapper").hasClass("pinned");
      $("#sidebar").hover(
        function () {
          //console.log("mouseenter");
          $(".page-wrapper").addClass("sidebar-hovered");
        },
        function () {
          //console.log("mouseout");
          $(".page-wrapper").removeClass("sidebar-hovered");
        }
      );
    });

    // Toggle sidebar overlay
    $("#overlay").on("click", function () {
      $(".page-wrapper").toggleClass("toggled");
    });

    // Added by Srinu
    $(function () {
      // When the window is resized,
      $(window).resize(function () {
        // When the width and height meet your specific requirements or lower
        if ($(window).width() <= 768) {
          $(".page-wrapper").removeClass("pinned");
        }
      });
      // When the window is resized,
      $(window).resize(function () {
        // When the width and height meet your specific requirements or lower
        if ($(window).width() >= 768) {
          $(".page-wrapper").removeClass("toggled");
        }
      });
    });
  }

  stickyHeader() {
    // Sticky Header
    const header = document.querySelector('.app-header');
    function updateStickyHeader() {
      if (window.scrollY > 10) {
        header.classList.add('sticky-header');
      } else {
        header.classList.remove('sticky-header');
      }
    }
    window.addEventListener('scroll', updateStickyHeader);
    // Apply on page load
    updateStickyHeader();
  }

  initToasts() {
    // Helper function to set up toast button listeners
    function setupToastButton(btnId, toastId) {
      const btn = document.getElementById(btnId);
      if (btn) {
        btn.addEventListener('click', function () {
          const toastElement = document.getElementById(toastId);
          if (toastElement) {
            const toast = new Toast(toastElement);
            toast.show();
          }
        });
      }
    }

    // Basic Toast
    setupToastButton('liveToastBtn', 'liveToast');

    // Placement Toasts
    setupToastButton('topLeftToastBtn', 'topLeftToast');
    setupToastButton('topRightToastBtn', 'topRightToast');
    setupToastButton('bottomLeftToastBtn', 'bottomLeftToast');
    setupToastButton('bottomRightToastBtn', 'bottomRightToast');

    // Colored Toasts
    setupToastButton('primaryToastBtn', 'primaryToast');
    setupToastButton('successToastBtn', 'successToast');
    setupToastButton('dangerToastBtn', 'dangerToast');
    setupToastButton('warningToastBtn', 'warningToast');
    setupToastButton('infoToastBtn', 'infoToast');

    // Icon Toasts
    setupToastButton('infoIconToastBtn', 'infoIconToast');
    setupToastButton('successIconToastBtn', 'successIconToast');
    setupToastButton('errorIconToastBtn', 'errorIconToast');
    setupToastButton('warningIconToastBtn', 'warningIconToast');
  }

  initTooltips() {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl);
    });
  }

  initPopovers() {
    var popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new Popover(popoverTriggerEl);
    });
  }
}

export default LavishTemplate;